import { Link } from 'react-router-dom'
import './NotFoundPage.css'

function NotFoundPage() {
  return (
    <div className="not-found-page">
      <h1>404 - Page Not Found</h1>
      <p className="not-found-message">
        The page you are looking for does not exist.
      </p>
      <Link to="/" className="btn btn-primary">Go to Home Page</Link>
    </div>
  )
}

export default NotFoundPage